import { FilterProcessor, FilterRenderer, FilterManager } from "converterFilterClasses";

class FlexaConverterFilters extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.currentRole = this.dataset.currentRole;

    this.initializeDomElements();
    this.filterProcessor = new FilterProcessor();
    this.filterRenderer = new FilterRenderer(this.domElements);
    this.filterManager = new FilterManager(this.domElements);

    this.setupEventListeners();
  }

  initializeDomElements() {
    this.domElements = {
      filterLists: this.querySelectorAll("[data-filter-list]"),
      confirmBtn: this.querySelector("[data-close][data-filter]"),
      resetBtn: this.querySelector("[data-reset-filter]"),
      activeFilters: document.querySelector(`[data-active-filters="${this.currentRole}"]`),
    };
  }

  setupEventListeners() {
    document.addEventListener("collection-selected", (event) =>
      this.handleCollectionSelected(event.detail)
    );
    this.domElements.resetBtn.addEventListener("click", () => this.handleReset());
    this.domElements.confirmBtn.addEventListener("click", () => this.dispatchFiltersSelected());

    this.domElements.activeFilters.addEventListener("click", (event) => {
      const pill = event.target.closest(".flexa-converter__filter-pill");
      if (pill) this.handleFilterPillClick(event, pill);
    });
  }

  handleCollectionSelected(selectedCollection) {
    const filters = this.filterProcessor.processCollectionFilters(selectedCollection);
    this.filterRenderer.renderFilters(filters);
    this.filterManager.resetFilters();
  }

  handleFilterPillClick(event, pill) {
    event.stopPropagation();

    const filterName = pill.dataset.filterName;
    const filterValue = pill.dataset.filterValue;

    const checkbox = this.querySelector(
      `input[data-filter-name="${filterName}"][data-filter-value="${filterValue}"]`
    );

    if (checkbox) {
      checkbox.checked = false;
      checkbox.dispatchEvent(new Event("change", { bubbles: false }));
    }

    pill.remove();
    this.dispatchFiltersSelected();
  }

  dispatchFiltersSelected() {
    const filterGroups = this.filterManager.getSelectedFilterGroups();
    this.filterRenderer.renderActiveFilters(filterGroups);
    document.dispatchEvent(
      new CustomEvent("filters-selected", {
        detail: { filterGroups, role: this.currentRole },
      })
    );
  }

  handleReset() {
    const activeFilters = document.querySelectorAll("input[data-filter-name][data-filter-value]");
    activeFilters.remove();

    this.filterManager.resetFilters();
    this.dispatchFiltersSelected();
    this.domElements.confirmBtn.click();
  }
}

customElements.define("flexa-converter-filters", FlexaConverterFilters);
